import * as React from 'react';
import { useAiGeneratedDisclaimerStyles_unstable } from './useAiGeneratedDisclaimerStyles.styles';
import type { ForwardRefComponent, TextProps } from '@fluentui/react-components';
import { renderText_unstable, useText_unstable } from '@fluentui/react-components';
import { useCopilotMode, useDesignVersion } from '@fluentui-copilot/react-provider';
import type { AiGeneratedDisclaimerState, AiGeneratedDisclaimerProps } from './AiGeneratedDisclaimer.types';

export const AiGeneratedDisclaimer: ForwardRefComponent<AiGeneratedDisclaimerProps> = React.forwardRef((props, ref) => {
  'use no memo';

  const state = useText_unstable({ as: 'span', ...props } as TextProps, ref) as AiGeneratedDisclaimerState;

  state.mode = useCopilotMode(props.mode);
  state.designVersion = useDesignVersion(props.designVersion);

  useAiGeneratedDisclaimerStyles_unstable(state);

  return renderText_unstable(state);
});

AiGeneratedDisclaimer.displayName = 'AiGeneratedDisclaimer';
